<script>
import {Prop, Vue} from 'vue-property-decorator';
import ZTIcon from '../zt-icon';

const prefix = 'zt-message-box';

export default class ZTMessage extends Vue {
    @Prop({type: [Object, String], default: ''}) message

    render() {
        const { message } = this;
        return <div class={`${prefix}-content`}>
            <div class={`${prefix}-content-icon`}>
                <ZTIcon type="warning"/>
            </div>
            <div class={`${prefix}-content-message`}>{message}</div>
        </div>
    }
}
</script>
